export class AssetTypeModel {
  id: number;
  name: string;
  createdBy: string;
  isActive: boolean;
  updatedBy: string;
}
